/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
import React, {useCallback, useEffect, useState} from "react";
import { useLocation } from 'react-router-dom';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import debounce from 'lodash.debounce';

import * as Actions from "actions";

import {
  TextField, InputAdornment, IconButton, Container, Typography, Chip, Box, Grid, Stack, Pagination,
} from "@mui/material";
import { Refresh } from "@mui/icons-material";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import NearMeIcon from '@mui/icons-material/NearMe';

import {
  Notification,
} from "components/Atoms";
import { Modal, Backdrop, Fade, Button } from "@mui/material";

import Autocomplete from "@mui/material/Autocomplete";
import UserSellerShop from "components/elements/user/shops/UserSellerShop";
import UserSellerShopView from "components/elements/user/shops/UserSellerShopView";
import UserSellerShopDetailModal from "components/elements/user/shops/UserSellerShopDetailModal";
import MockSearchResults from "components/elements/main/MockSearchResults";
import { H5, H6 } from "components/CustomTypography";
import {SearchOutlinedIcon} from "../UserCombinedSearch";
import CustomSectionCreator from "components/CustomSectionCreator";
import LazyImage from "components/LazyImage";
import {
  getCategoryBreadcrum,
  getImage,
  getLocationBreadcrum,
  isMarketPlaceOnly,
  isFeatureSupported, getPlatform, analyticsTrackPageView, analyticsTrackEvent, getURI
} from "helpers/utils";
import UserShopLocationSlider from "components/elements/user/UserShopLocationSlider";
import * as ActionTypes from "constants/ActionTypes";
import StoriesPlayer from "components/StoriesPlayer/StoriesPlayer";
import CustomFlexBox from "components/CustomFlexBox";
import UserShopStatusSelector from "components/elements/user/shops/UserShopStatusSelector";
import ButtonComponent from "components/Button";
import UserShopsTrackUserViewedSlider from "components/elements/user/shops/UserShopsTrackUserViewedSlider";
import UserProductCategorySlider from "components/elements/user/products/UserProductCategorySlider";
import MobileCategoryNav from "components/mobile-category-nav";

import UnifiedSwipeTrigger from "components/elements/main/UnifiedSwipeTrigger";
import { UnifiedLongPressableObject } from "components/elements/main/UnifiedLongPressableObject";
import UnifiedPullDown from "components/elements/main/UnifiedPullDown";
import UnifiedPullToRefresh from "components/elements/main/UnifiedPullToRefresh";
import CloseIcon from "@mui/icons-material/Close";

const UserShopSearch = (props) => {

  const [state, setState] = useState({
    limit: 5,
    hasMoreItems: true,
    breakPoint: "lg",
    bShowSearchModal: false,
  });
  const [shopState, setShopState] = useState("");
  const [shopModeState, setShopModeState] = useState("PREVIEW");
  const [optionValues, setOptionValues] = useState([]);
  const [locationState, setLocationState] = useState("");
  const [categoryState, setCategoryState] = useState("");
  const [marketState, setMarketState] = useState("");
  const [sortState, setSortState] = useState("popular");
  const [currentPage, setCurrentPage] = useState(1);
  const [showLocationSlider, setShowLocationSlider] = useState(false);

  const [loadStoryState, setLoadStoryState] = useState(false);
  const [loadModalState, setLoadModalState] = useState(false);
  const [loadIdState, setLoadIdState] = useState("");
  const [currentStoryIndex, setCurrentStoryIndex] = useState(null);
  const [showModalShop, setShowModalShop] = useState(null);

  const [hasTriedLoading, setHasTriedLoading] = useState(false);

  const {
    serviceError, reqStatus, isLoading,
    shops, shopdetail, currency,
    userMainSearchShops, userMainGetShopInfoById,
    userMainSearchShopKeywords, citylocations,
    userMainResetSearchShops, userMainResetSearchShopKeywords,
    userMainAddStoreToFavlist,
    commonCategoryList,
    searchkeywords, match, history, symbol = "$", marketId, wholesale, pagination
  } = props;

  const { keywords } = searchkeywords;

  const {
    resetvalue,
  } = state;

  const { query } = match.params;
  const { sort } = match.params;
  const { location } = match.params;
  const { market } = match.params;
  const urlparams = useLocation();

  const { categories } = commonCategoryList;

  const closeShopModal = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setShowModalShop(null);
  };

  useEffect(() => {

    analyticsTrackPageView("/shops", "Main Shops");

    // Get a specific query parameter
    const checkLoadState = new URLSearchParams(urlparams.search).get('ls');

    if (checkLoadState) {
      if (checkLoadState === "1") {
        setLoadStoryState(true);
      } else if (checkLoadState === "2") {
        setLoadModalState(true);
      }
    }

    const loadIndex = new URLSearchParams(urlparams.search).get('li');

    if (loadIndex) {
      setLoadIdState(loadIndex);
    }

    if (sort) {
      setSortState(sort);
    }

    if (query) {
      userMainResetSearchShops();
      setHasTriedLoading(false);
      userMainSearchShops(query, sort, "", marketId, currentPage, wholesale, categoryState._id);
    } else if (location) {
      // need lat/lng to do query
      setLocationState(location);
      setHasTriedLoading(false);
      userMainSearchShops("", sort, location, marketId, currentPage, wholesale, categoryState._id);
    } else if (market) {
      setMarketState(market);
      setHasTriedLoading(false);
      userMainSearchShops("", sort, market, marketId, currentPage, wholesale, categoryState._id);
    } else {
      setHasTriedLoading(false);
      userMainSearchShops("", sort, "", marketId, currentPage, wholesale, categoryState._id);
    }
  }, []);

  const handleRefresh = () => {
    setHasTriedLoading(false);
    userMainSearchShops(query, sortState, locationState, marketId, currentPage, wholesale, categoryState._id);
  };

  const sendNotification = (type, { title, description = "" }) => {
    Notification[type]({
      message: title,
      description,
    });
  };

  useEffect(() => {
    if (!isLoading) {
      setHasTriedLoading(true);
    }
  }, [isLoading]);

  useEffect(() => {
    if (!isLoading && shops.length > 0 && loadStoryState) {
      openStoriesView();
      setLoadStoryState(false);
    }
  }, [isLoading, shops, loadStoryState]);

  useEffect(() => {
    if (
        loadModalState &&
        shops.length > 0 &&
        loadIdState !== "" &&
        shops[loadIdState]
    ) {
      openModalView();
      setLoadModalState(false);
    }
  }, [loadModalState, shops, loadIdState]);

  useEffect(() => {
    if (serviceError && reqStatus) {
      const feedback = {
        title: "Something went wrong!",
        description: serviceError.statusText,
      };
      sendNotification("error", feedback);
    }
    switch (reqStatus) {
      default:
        break;
    }
  }, [serviceError, reqStatus]);

  const runSearch = (keyword) => {
    userMainResetSearchShopKeywords();
    setState({ resetvalue: "" });
    history.push(`/shops/search/${keyword}`);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      runSearch(e.target.value);
    }
  };

  const selectItem = (e, value) => {
    if (e.key === "Enter") {
      runSearch(value);
    }
  };

  const setKeyword = (option, type) => {
    if (type === "selectOption") {
      history.push(`/shop/${option.key}`)
    }
  };

  const runKeywordSearch = (value) => {
    setState({ resetvalue: value });
    if ((value.length > 1)) {
      userMainSearchShopKeywords(value,
          props.bootupInfo.appState.subdomain_shopId, true, props.bootupInfo.appState.isWebsite);
    }
  };

  const debouncedChangeHandler = useCallback(
      debounce(runKeywordSearch, 300)
      , []);

  const handleDelete = () => {
    history.push("/shops");
  };


  const handleAddShopFavourite = (shopId) => {
    userMainAddStoreToFavlist(shopId);
  };

  const handleShopEdit = (mode, shop, index, withStory, reset) => () => {

    if (withStory) {
      setLoadIdState(index);
    }

    setShopModeState(mode);

    if (reset) {
      setShopState({
        selectedShop: {
          shop_id: "",
          id: "",
          title: "",
          logo: [],
          video: [],
          images: [],
          topproducts: [],
          area: "",
        },
      });
    } else {

      analyticsTrackEvent("User Interaction", "Main Shop Clicked : Story - " + withStory, shop.title + " " + shop.id);

      setShopState({
        selectedShop: {
          shop_id: shop.shop_id,
          id: shop.id,
          title: shop.title,
          logo: shop.logo,
          video: shop.video,
          images: shop.images,
          topproducts: shop.topproducts,
          area: shop.area,
        },
      });
    }
  };


  useEffect(() => {
    setOptionValues(keywords);
  }, [keywords]);


  const handleViewShop = (shop, index) => {
    setShopModeState("VIEWDETAIL");
    //history.push(getURI(process.env.REACT_APP_TYPE, "shop_home", shop.shop_id, "", ""));
  };

  const handleLocationSelect = (loc) => {
    setLocationState(loc.id);
    setCurrentPage(1);
    setHasTriedLoading(false);
    userMainSearchShops("", sortState, loc.id, marketId, 1, wholesale, categoryState._id);
  };

  const handleCategorySelect = (cat) => {
    setShopModeState("PREVIEW");
    setCurrentPage(1);
    setCategoryState(cat);
    setHasTriedLoading(false);
    userMainSearchShops("", sortState, locationState, marketId, 1, wholesale, cat._id);
  };

  const handleSelectCategorySet = (cat) => {
    setCurrentPage(1);
    setCategoryState(cat);
    setHasTriedLoading(false);
    userMainSearchShops("", sortState, locationState, marketId, 1, wholesale, cat._id);
  };

  const setShopStatus = (status) => {
    setSortState(status);
    setCurrentPage(1);
    setHasTriedLoading(false);
    userMainSearchShops(query, status, locationState, marketId, 1, wholesale, categoryState._id);
  };

  const handleRestAll = () => {
    setCurrentPage(1);
    setSortState("");
    setLocationState("");
    setCategoryState("");
    setHasTriedLoading(false);
    userMainSearchShops(query, "", "", marketId, 1, wholesale, "");
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    setHasTriedLoading(false);
    userMainSearchShops(query, sortState, locationState, marketId, value, wholesale, categoryState._id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleResetResultsStory = () => {
    setShopModeState("PREVIEW");
    setLoadIdState("");
  };

  const handleResetShopStory = () => {
    setLoadIdState("");
  };

  const handleModalView = (shop, index) => (event) => {

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    setShowModalShop(shop);

    setShopState({
      selectedShop: {
        shop_id: shop.shop_id,
        id: shop.id,
        title: shop.title,
        logo: shop.logo,
        video: shop.video,
        images: shop.images,
        topproducts: shop.topproducts,
        area: shop.area,
      },
    });
  }

  const openCategoryList = () => {
    setShopModeState("CATEG");
  };

  const openStoriesView = () => {
    setShopModeState("STORIES");
  };

  const openModalView = () => {
    handleModalView(shops[loadIdState], loadIdState)(null);
    setShopModeState("PREVIEW");
  };

  const MobileViewOnClick = () => {
    if (window.innerWidth <= 500 && (match.path !== "/shops/search")) {
      props.history.push("/shops/search");
    }
  };

  let isModalSearch = false;

  const renderNoResults = () => (
      <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '50px',
          }}
      >
        <ButtonComponent
            type="primary"
            variant="outlined"
            name="Reset"
            size="medium"
            onClick={handleRestAll}
        />
      </Box>
  );




  var type = {
    'new': 'New ' + process.env.REACT_APP_SHOP_TITLE,
    'popular': 'Popular ' + process.env.REACT_APP_SHOP_TITLE,
    'default': 'Popular ' + process.env.REACT_APP_SHOP_TITLE
  };

  const renderResults = () => (
      <div>
        {/*isFeatureSupported("shopreels") &&
            <CustomFlexBox sx={{
              display: 'flex',
              flexDirection: 'row',
              position: 'fixed',
              width: '100%',
              bottom: 70,
              justifyContent: 'center',
              zIndex: 'modal'
            }}>
              <Button
                  sx={{marginRight: '2px'}}
                  size="large"
                  color="primary"
                  variant="contained"
                  onClick={openStoriesView}
              >
                <SlideshowIcon /> &nbsp; View as {process.env.REACT_APP_REELS_TAG}
              </Button>
            </CustomFlexBox>
        */}
        <Grid item container xs={12} sm={12} md={12} lg={12} spacing={2}>
          {shops.map((shop, index) => (
              <Grid item xs={6} sm={3} md={3} lg={3} key={index}>
                <UnifiedLongPressableObject item={shop} index={index}
                                            onLongPress={handleModalView(shop, index)}>
                  <UserSellerShop
                      shop={shop}
                      symbol={currency}
                      onMainClick={handleModalView(shop, index)}
                      onArrowClick={handleShopEdit("STORIES", shop, index, true, false)}
                      onBottomClick={handleModalView(shop, index)}
                      /* onBottomClick={handleShopEdit("VIEWDETAIL", shop, index, false, false)} - do not go to direct link */
                      key={`${index + 1}`}
                  />
                </UnifiedLongPressableObject>
              </Grid>
          ))}
        </Grid>
      </div>
  );

  // stories data

  const storiesData = shops.map((shop) => {
    const {id, shop_id, title, logo, video, topproducts, area} = shop;

    let stories = [];

    if (video && video.length > 0) {
      stories.push({
        video: video[0].cdn.secure_url,
        videoimage: logo && logo[0].cdn.secure_url
      });
    } else {
      topproducts && topproducts.map((product) => (
          stories.push({
            image: product.cdn.secure_url,
          })
      ));
    }

    if (stories.length < 1) {
      stories.push({
        image: logo && logo[0].cdn.secure_url,
      });
    }

    return (
        {
          user: {
            avatar: logo[0].cdn.secure_url,
            name: title,
            linkTitle1: "View Shop",
            area: area,
          },
          item: shop,
          favId: shop_id,
          stories: stories,
        }
    );
  });

  const renderResultsAsStories = () => (
      <div>
        <StoriesPlayer
            loadIndex={loadIdState}
            storiesData={storiesData}
            setAsFav={handleAddShopFavourite}
            onButton1Click={handleViewShop}
            onIndexChange={(index) => setCurrentStoryIndex(index)}
            onCancel={() => handleResetResultsStory()}
        />
        <UnifiedSwipeTrigger
            onLeftSwipeComplete={() => setShopModeState("PREVIEW")}
            onRightSwipeComplete={() => handleViewShop(shops[currentStoryIndex], currentStoryIndex)}
        />
      </div>
  );

  const handleShopButtonClick = (shopId) => {
    history.push(`/shop/${shopId}`);
  };

  const renderShopDetail = () => (
      <>
        <UserSellerShopView
            setState={(value, field) => setShopState({
              ...state,
              selectedShop: {
                ...selectedShop,
                [field]: value,
              },
            })}
            symbol={symbol}
            history={history}
            selectedShop={selectedShop}
            onAddToFavlistClicked={handleAddShopFavourite}
            onCancel={() => setShopModeState("PREVIEW")}
            excludeHome={wholesale}
        />
        <UnifiedSwipeTrigger
            onLeftSwipeComplete={() => setShopModeState("PREVIEW")}
            onRightSwipeComplete={() => handleShopButtonClick(selectedShop.id)}
        />
      </>
  );

  const renderShopModal = () => (
      <>
        <UserSellerShopDetailModal
            setState={(value, field) => setShopState({
              ...state,
              selectedShop: {
                ...selectedShop,
                [field]: value,
              },
            })}
            symbol={symbol}
            history={history}
            selectedShop={selectedShop}
            onAddToFavlistClicked={handleAddShopFavourite}
            onCancel={() => setShopModeState("PREVIEW")}
            excludeHome={wholesale}
        />
      </>
  );


  const renderCategoriesNav = () => (
      <>
        <MobileCategoryNav
            categories={categories}
            categoryState={categoryState}
            selectCategoryClicked={handleCategorySelect}
        />
        <UnifiedSwipeTrigger
            onLeftSwipeComplete={() => setShopModeState("PREVIEW")}
        />
      </>
  );


  const renderShopAsStories = (shopData) => (

      <div>

        {renderShopDetail()}

        <StoriesPlayer
            storiesData={shopData}
            setAsFav={handleAddShopFavourite}
            onButton1Click={handleViewShop}
            onCancel={() => handleResetShopStory()}
        />
      </div>

  );

  const renderSearchHelpMobile = () => (
      <Container>
        <Box>
          {
              window.innerWidth <= 500
              && (match.path === "/shops/search")
              && optionValues.map((element) => (
                  <Box m={2} alignItems="center" width="100%" display="flex" onClick={() => history.push(`/shop/${element.value}`)}>
                    <Box width="75%">
                      <H5 fontSize={16} ellipsis>
                        {element.label}
                      </H5>
                      <H6 fontSize={12} ellipsis>
                        {element.sublabel}
                      </H6>
                    </Box>
                    <Box width="25%">
                      <LazyImage
                          src={getImage(element.images)}
                          width={60}
                          height={60}
                          mx="auto"
                      />
                    </Box>
                  </Box>
              ))
          }
        </Box>
      </Container>
  );

  const renderSearchModule = () => (
      <>

        {/*
      <Container onClick={MobileViewOnClick}>
          <Box mb={2}>
        {
            window.innerWidth <= 500
            && (match.path === "/shops/search") ? isModalSearch = true : isModalSearch = false
          }
        <Autocomplete
          id="autocomplete1"
          onClose={setKeyword}
          disableClearable
          freeSolo
          inputValue={resetvalue}
          onOpen={() => setState({ selected: false })}
          value={resetvalue}
          onKeyPress={
            handleKeyPress
          }
          onChange={
            (event, newValue) => selectItem(event, newValue)

          }
          onSelect={
            (input) => debouncedChangeHandler(input.target.value)
          }
          options={
            window.innerWidth <= 500 ? [] : optionValues
          }
          renderOption={(props, option) => (
              <Box component="li" {...props} key={option.value}>
                {option.label}
              </Box>
          )}
          renderInput={(params) => (
            <TextField
                {...params}
              InputProps={{
                sx: {
                  height: 44,
                  paddingRight: 0,
                  borderRadius: 0,
                  color: "grey.900",
                  overflow: "hidden",
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "primary.main",
                  },
                },
                startAdornment: <SearchOutlinedIcon fontSize="small" />,
              }}
              autoFocus={isModalSearch}
              placeholder={`Search ${process.env.REACT_APP_SHOP_TITLE}`}
            />
          )}
        />
        </Box>
      </Container>

      {
        renderSearchHelpMobile()
      }
      */}

        <Container>
          { match.path !== "/"
              && (match.path === "/shops/search/:query" ||
                  match.path === "/shops/search/:query" ||
                  match.path === "/shops" ||
                  match.path === "/shops/sort/:sort" ||
                  match.path === "/shops/location/:location" ||
                  match.path === "/shops/market/:market") && (
                  <>

                    <Box width="100%" margin="0px">
                      <UserProductCategorySlider
                          {...props}
                          isDirect={false}
                          includeAll={true}
                          openCategoryList={openCategoryList}
                          selectedCategory={categoryState._id}
                          handleSelectCategoryLink={handleSelectCategorySet}
                          handleSelectCategorySet={handleSelectCategorySet}

                      />
                    </Box>

                    {isMarketPlaceOnly() && sortState !== "nearby" && showLocationSlider &&
                        <UserShopLocationSlider
                            {...props}
                            isDirect={false}
                            isProduct={false}
                            setLocation={locationState}
                            headerTitle={"By Location: " + (type[sortState] || type['default'])}
                            handleSelectCategoryLink={handleLocationSelect}
                            handleSelectCategorySet={handleLocationSelect}
                        />
                    }

                    {query ? (<CustomSectionCreator title={"Searching: '" + query + "'"} />) : (<CustomFlexBox bgcolor="header" justifyContent="space-between" alignItems="center" p={1} />)}
                    {/* !query && (<CustomSectionCreator title={(type[sortState] || type['default']) + getLocationBreadcrum(citylocations, locationState)} />) */}



                    <CustomFlexBox alignItems="center" mt={2} mb={2} sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      width: '100%',
                    }}>
                      <Box width="45%">
                        <UserShopStatusSelector
                            onStatusSelect={setShopStatus}
                            shopstatus={sortState}
                        />
                      </Box>
                      <Box width="25%">
                        <ButtonComponent
                            type="primary"
                            variant="outlined"
                            name="View All"
                            size="medium"
                            onClick={handleRestAll}>
                        </ButtonComponent>
                      </Box>
                      <Box width="30%" display="flex" justifyContent="flex-end">
                          {isMarketPlaceOnly() && sortState !== "nearby" && (
                              <IconButton
                                  onClick={() => setShowLocationSlider(!showLocationSlider)}
                                  color="primary"
                                  aria-label="toggle location filter"
                              >
                                  <NearMeIcon />
                              </IconButton>
                          )}
                      </Box>
                    </CustomFlexBox>



                    {isLoading ? (
                        <MockSearchResults />
                    ) : shops.length > 0 ? (
                        renderResults()
                    ) : hasTriedLoading ? (
                        renderNoResults()
                    ) : null}

                    <CustomFlexBox alignItems="center" mb={4} sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      width: '100%',
                    }}>
                      {/* Pagination */}
                      {!isLoading && shops.length > 0 && pagination && (
                          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 2, width: '100%' }}>
                            <Stack spacing={2}>
                              <Pagination
                                  count={pagination.totalPages}
                                  page={currentPage}
                                  onChange={handlePageChange}
                                  color="primary"
                                  size="large"
                              />
                            </Stack>
                          </Box>
                      )}
                    </CustomFlexBox>

                    <UserShopsTrackUserViewedSlider includeHeader={true} />

                  </>
              )}
        </Container>
      </>
  );

  const renderShopMode = (shopMode) => {
    switch (shopMode) {

      case "STORIES":
        return renderResultsAsStories();

      case "CATEG":
        return renderCategoriesNav();

      case "STORIESVIEW":

        const {id, shop_id, title, logo, video, topproducts, area} = selectedShop;

        let shopStoryData = [];
        let stories = [];

        if (video && video.length > 0) {
          stories.push({
            video: video[0].cdn.secure_url,
            videoimage: logo && logo[0].cdn.secure_url
          });
        } else {
          topproducts && topproducts.map((product) => (
              stories.push({
                image: product.cdn.secure_url,
              })
          ));
        }

        if (stories.length < 1) {
          stories.push({
            image: logo && logo[0].cdn.secure_url,
          });
        }

        shopStoryData.push(
            {
              user: {
                avatar: logo[0].cdn.secure_url,
                name: title,
                linkTitle1: "View Shop",
                area: area,
              },
              item: selectedShop,
              favId: shop_id,
              stories: stories,
            }
        );

        return renderShopAsStories(shopStoryData);

      case "VIEWDETAIL":
        return renderShopDetail();

      case "PREVIEW":
      default:
        // causes render again on closing stories - reload of objects inside
        return renderSearchModule();
    }
  };

  const { selectedShop = {} } = shopState;

  return (
      <Container>
        {shopModeState === "PREVIEW" ? (
          <UnifiedPullToRefresh
            onRefresh={handleRefresh}
            isRefreshing={isLoading}
          >
            {renderShopMode(shopModeState)}
          </UnifiedPullToRefresh>
        ) : (
          renderShopMode(shopModeState)
        )}

        <Modal
            open={!!showModalShop}
            onClose={closeShopModal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ 
              timeout: 300,
              onClick: (e) => e.stopPropagation()
            }}
            disableScrollLock={false}
            keepMounted={false}
            sx={{
              '& .MuiBackdrop-root': {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              }
            }}
        >
          <Fade in={!!showModalShop}>
            <Box onClick={(e) => e.stopPropagation()}>
              <IconButton
                  onClick={closeShopModal}
                  sx={{
                    position: 'absolute',
                    top: '2%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 1301,
                    backgroundColor: 'black',
                    color: 'white',
                    width: 48,
                    height: 48,
                    pointerEvents: 'auto',
                    '&:hover': {
                      backgroundColor: 'grey.800',
                    },
                  }}
              >
                <CloseIcon />
              </IconButton>
              <Box
                  sx={{
                    position: 'absolute',
                    top: '8%',
                    height: '95%',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                  }}
              >
                {/* // checking showModalShop.id === selectedShop.id avoids race condition */}
                {showModalShop && selectedShop && showModalShop.id === selectedShop.id && (<><Box sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: '96%',
                      height: '95%',
                      overflow: 'auto',
                      boxSizing: 'border-box',
                      bgcolor: 'background.paper',
                      borderRadius: 2,
                      boxShadow: 24,
                      p: 2,
                    }}>
                      <UnifiedPullDown onPullDown={closeShopModal} threshold={60}>
                        {renderShopModal()}
                      </UnifiedPullDown>
                    </Box>
                      <UnifiedSwipeTrigger
                          onLeftSwipeComplete={() => { closeShopModal(null); setShopModeState("PREVIEW")} }
                          onRightSwipeComplete={() => { closeShopModal(null); handleShopButtonClick(selectedShop.id)} }
                      />
                    </>
                )}
              </Box>
            </Box>
          </Fade>
        </Modal>
      </Container>
  );
};

UserShopSearch.defaultProps = {
  currency: "",
};

UserShopSearch.propTypes = {
  currency: PropTypes.string,
  addProductToCart: PropTypes.func.isRequired,
  shops: PropTypes.arrayOf(PropTypes.object).isRequired,
  pagination: PropTypes.object,
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  searchkeywords: PropTypes.objectOf(PropTypes.any).isRequired,
  citylocations: PropTypes.objectOf(PropTypes.any).isRequired,
  addProductToWishlist: PropTypes.func.isRequired,
  addToCompare: PropTypes.func.isRequired,
  userMainGetShopInfoById: PropTypes.func.isRequired,
  userMainSearchShops: PropTypes.func.isRequired,
  userMainSearchShopKeywords: PropTypes.func.isRequired,
  userMainResetSearchShopKeywords: PropTypes.func.isRequired,
  userMainResetSearchShops: PropTypes.func.isRequired,
  userMainAddStoreToFavlist: PropTypes.func.isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const userShopSearch = connect(
    ({ userMainShops, bootupInfo, userMainProducts }) => ({
      bootupInfo,
      currency: bootupInfo.symbol,
      reqStatus: userMainShops.reqStatus,
      isLoading: userMainShops.isLoading,
      serviceError: userMainShops.serviceError,
      citylocations: bootupInfo.citylocations,
      shops: userMainShops.searchshops,
      pagination: userMainShops.pagination,
      searchkeywords: userMainShops.searchkeywords,
      shopdetail: userMainShops.shopDetail,
      commonCategoryList: userMainProducts.categoryList,
    }),
    (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(UserShopSearch);

export { userShopSearch as default };
